import React, { Children, useState } from 'react';

function ViewDetails({ children }) {
	const [active, setActive] = useState(false);
	function getConnectedChildren() {
		const connectedChildren = [];
		const compressed = Children.toArray(children)[0];
		const expanded = Children.toArray(children)[1];
		const connectedCompressed = React.cloneElement(compressed, {
			// onClick: toggleDropdown,
			active: active,
		});
		const connectedExpanded = React.cloneElement(expanded, {
			active: active,
			toggleActive: setActive,
		});
		connectedChildren.push(connectedCompressed, connectedExpanded);
		return connectedChildren;
	}

	return <>{getConnectedChildren()}</>;
}

export default ViewDetails;
